import { useEffect, useState, type ReactNode } from "react";

interface ClientOnlyProps {
  children: ReactNode;
  /** Rendered during SSR + the first client render, before the post-mount switch. */
  fallback?: ReactNode;
}

/**
 * Render `children` only after the component has mounted on the client.
 * Keeps browser-only components (Three.js / Canvas / window APIs) out of
 * the SSR render tree so vike ships a minimal server-rendered HTML, and
 * prevents hydration mismatches when the component's output depends on
 * runtime-only inputs (viewport size, localStorage, etc.).
 *
 * Minimal pattern — use this when a full dynamic import isn't needed.
 */
export default function ClientOnly({ children, fallback = null }: ClientOnlyProps) {
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);
  return mounted ? <>{children}</> : <>{fallback}</>;
}
